import React, { useRef } from "react";
import { useRoleModel } from "../roleModel";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, ISelectOption, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";
import { useLockFn } from "ahooks";
import { useState } from "react";
import { useEffect } from "react";
import { userService } from "../../user/UserService";
import { IMdUserDetail } from "@src/views/authPortal/rate/set/rateSetTypes";
import { Divider, message, Modal, Tag } from "antd";
import { roleService } from "../RoleService";
import { globalPrompt } from "@src/components/YhMessage";


export function DetailUsers() {
    const {
        userVisible: visible,
        setUserVisible,
        loadData,
        selectedRowData
    } = useRoleModel();
    

    const onCancel = () => {
        setUserVisible(false);
        loadData()
    }

    useEffect(() => {
        if(visible){
            setUserList([])
            getDeFaultUserList()
        }
    },[visible])

    const getDeFaultUserList = () => {
        let data = { page: {pageSize: 100000, pageNum: 1}, roleCode: selectedRowData?.code };
        return userService.findUserDetail(data).then(res => {
            const { retData: { records } } = res;
            setUserList([...records])
        })
    }

    const [userList, setUserList] = useState<IMdUserDetail[]>([])


    const userChange = (val: string, option: IMdUserDetail) => {
        let list = [...userList]
        if(list.findIndex(user => user.code === option.code) === -1){
            setUserList([...list, option])
        }
       
    }

    const fetchUserList = async (value: string) => {
        // if (!value) return await fn();
        let data = { page: {pageSize: 15, pageNum: 1}, name: value };
        return userService.findUserDetail(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                ...item,
                label: item.name,
                value: item.code,
            })) : [];
        })
    }

    const formRef = useRef<IYhFormRef>();
    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: false,
        initialValues: {
            name: selectedRowData?.name,
        },
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: '选择成员',
                fieldName: 'userId',
                onSelectChange: userChange,
                placeholder: '成员',
                selectfetchList: fetchUserList,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "角色名称",
                fieldName: "name",
                disable: true,
                span: 12,
            }
        ]
    };

    const onOk = useLockFn(async () => {
        try {
            let params = {
                roleCode: selectedRowData?.code as string,
                userCodes: userList.map(i => i.code as string)
            }
            roleService.updateRoleUsers(params).then( async res => {
                await globalPrompt("message", { type: "success", text: '编辑成功!' });
                setUserVisible(false)
                loadData()
            })
        } catch (e) {
            console.log("失败!");
        }
    });

    const onUserRemove = (e: React.MouseEvent<HTMLElement>, user: IMdUserDetail) => {
        e.preventDefault()
        Modal.confirm({
            title: '删除',
            centered: true,
            closable: true,
            content: (<div>确定要删除用户--{user.name}</div>),
            onOk(){
                let list = [...userList]
                setUserList(list.filter(i => i.code !== user.code))
            }
        })
        
    }

   

    return (
        <YHDrawer
            {...{
                title: "人员信息",
                visible,
                onCancel,
                width: 700,
                showFooter: true,
                onOk,
            }}
        >
            <YhForm  {...formConfig} />
            <Divider />
            <p>分配人员</p>
            {
                userList.map(user => <Tag key={user.code} closable onClose={(e) => onUserRemove(e,user)} style={{marginBottom:"5px"}}>{user.name}</Tag>)
            }
           
        </YHDrawer >
    )
}